var _rect, _rect2, _path, _rect3, _rect4, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendBack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    fill: "#1E3A8A"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.4,
    y: 0.4,
    width: 17.2,
    height: 17.2,
    rx: 1.6,
    stroke: "#1E3A8A",
    strokeWidth: 0.8
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.2828 13.2828C13.1266 13.4391 12.8734 13.4391 12.7172 13.2828L10.1716 10.7373C10.0154 10.581 10.0154 10.3278 10.1716 10.1716C10.3278 10.0154 10.581 10.0154 10.7373 10.1716L13 12.4343L15.2627 10.1716C15.419 10.0154 15.6722 10.0154 15.8284 10.1716C15.9846 10.3278 15.9846 10.581 15.8284 10.7373L13.2828 13.2828ZM13.4 6L13.4 13L12.6 13L12.6 6L13.4 6Z",
    fill: "white"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 3,
    transform: "matrix(1 0 0 -1 3 13)",
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    transform: "matrix(1 0 0 -1 3 9)",
    fill: "white"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    width: 6,
    height: 1,
    transform: "matrix(1 0 0 -1 3 7)",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendBack);
export default __webpack_public_path__ + "static/media/Send_Back.641f13862cdae2de577bd58f68085b52.svg";
export { ForwardRef as ReactComponent };